import classNames from "classnames";
import { NoDataFoundProps } from "./types";
import Icon from "assets/icons";
import { useCopies } from "shared/hooks/useCopies";

export default function NoDataFound(props: NoDataFoundProps) {
  const copies = useCopies();
  return (
    <div
      className={classNames("noDataFound", {
        noDataFound_isOutlined: props.isOutlined
      })}
      style={{ height: props.height }}>
      <div
        className={classNames("noDataFound_header", {
          noDataFound_headerInline: props.inline
        })}>
        {props.icon ? (
          <div className="noDataFound_header--customIcon">
            <span className="noDataFound_header--providedIcon">{props.icon}</span>
            {!props.inline && (
              <span className="noDataFound_header--closeIcon">
                <Icon.Close />
              </span>
            )}
          </div>
        ) : !props.hideIcon && !props.inline ? (
          <Icon.NoResultLight />
        ) : (
          <Icon.NoResult />
        )}
        <p className="noDataFound_header--label">{props.label ? props.label : copies.get("no.results.found")}</p>
      </div>
      {props.infoText && <div className="noDataFound_info">{props.infoText}</div>}
      {props.action && <div className="noDataFound_action">{props.action}</div>}
    </div>
  );
}
